export const ANNOUNCEMENT_STATUS = {
  DRAFT: "draft",
  SCHEDULED: "scheduled",
  ACTIVE: "active",
  ARCHIVED: "archived",
};

export const getAnnouncementDateTime = (date, time = "00:00") => {
  if (!date) return null;

  const safeTime = time || "00:00";
  const dateTime = new Date(`${date}T${safeTime}`);

  if (Number.isNaN(dateTime.getTime())) return null;

  return dateTime;
};

export const getAnnouncementPostedDateTime = (announcement = {}) => {
  if (announcement.postedAtMs) {
    return new Date(announcement.postedAtMs);
  }

  if (announcement.postedDate) {
    return getAnnouncementDateTime(
      announcement.postedDate,
      announcement.postedTime || "00:00",
    );
  }

  if (announcement.createdAtMs) {
    return new Date(announcement.createdAtMs);
  }

  return announcement.createdAt?.toDate?.() || null;
};

export const getComputedAnnouncementStatus = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  const rawStatus = announcement.status;
  const currentDate = new Date(currentTimestamp);

  if (rawStatus === ANNOUNCEMENT_STATUS.DRAFT) {
    return ANNOUNCEMENT_STATUS.DRAFT;
  }

  if (rawStatus === ANNOUNCEMENT_STATUS.ARCHIVED) {
    return ANNOUNCEMENT_STATUS.ARCHIVED;
  }

  if (announcement.scheduleAnnouncement) {
    const scheduledAt = getAnnouncementDateTime(
      announcement.scheduleDate,
      announcement.scheduleTime,
    );

    if (scheduledAt && scheduledAt > currentDate) {
      return ANNOUNCEMENT_STATUS.SCHEDULED;
    }

    return ANNOUNCEMENT_STATUS.ACTIVE;
  }

  return rawStatus || ANNOUNCEMENT_STATUS.ACTIVE;
};

export const getAnnouncementStatusLabel = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  const status = getComputedAnnouncementStatus(announcement, currentTimestamp);

  if (status === ANNOUNCEMENT_STATUS.DRAFT) return "Draft";
  if (status === ANNOUNCEMENT_STATUS.SCHEDULED) return "Scheduled";
  if (status === ANNOUNCEMENT_STATUS.ARCHIVED) return "Archived";

  return "Active";
};

export const canEditAnnouncement = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  const computedStatus = getComputedAnnouncementStatus(
    announcement,
    currentTimestamp,
  );

  return (
    computedStatus === ANNOUNCEMENT_STATUS.DRAFT ||
    computedStatus === ANNOUNCEMENT_STATUS.SCHEDULED ||
    computedStatus === ANNOUNCEMENT_STATUS.ACTIVE
  );
};

export const canArchiveAnnouncement = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  const computedStatus = getComputedAnnouncementStatus(
    announcement,
    currentTimestamp,
  );

  return computedStatus !== ANNOUNCEMENT_STATUS.ARCHIVED;
};

export const canUnarchiveAnnouncement = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  const computedStatus = getComputedAnnouncementStatus(
    announcement,
    currentTimestamp,
  );

  return computedStatus === ANNOUNCEMENT_STATUS.ARCHIVED;
};

export const getUnarchivedStatus = (
  announcement = {},
  currentTimestamp = Date.now(),
) => {
  if (!announcement.scheduleAnnouncement) {
    return ANNOUNCEMENT_STATUS.ACTIVE;
  }

  const scheduledAt = getAnnouncementDateTime(
    announcement.scheduleDate,
    announcement.scheduleTime,
  );

  if (scheduledAt && scheduledAt > new Date(currentTimestamp)) {
    return ANNOUNCEMENT_STATUS.SCHEDULED;
  }

  return ANNOUNCEMENT_STATUS.ACTIVE;
};
